export default __webpack_public_path__ + "static/media/mxgasperi-background2.bf0834ee.jpg";